var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('h2',[_vm._v(" DESIGNATED MEDICAL SERVICE UNIT (MSU) ")]),_c('h4',[_vm._v(" The hospital chosen by the HMI member where he/she will have to go seek medical treatment or confinement. ")])])
}]

export { render, staticRenderFns }